/**
 * @name 阿里云人机验证
 */
import api from '@/api/common/index';
export default {
  data () {
    return {
      captcha: null, // 阿里验证码实例
      captchaButton: null, // 阿里验证码按钮实例
      captchaDisable: false, // 阿里云人机验证开启后不允许再次点击发送验证码
      timer: null, // 验证码定时器
      timerNum: 60,
      codeBtnText: '获取验证码',
    };
  },
  // mounted () {
  //   this.aLiYunCaptchaInit();
  // },
  beforeDestroy () {
    clearInterval(this.timer);
    this.clearALiYunCaptcha();
  },
  methods: {
    aLiYunCaptchaInit (disable) {
      if (this.captchaDisable || !disable) return;
      this.clearALiYunCaptcha();
      this.captchaButton = document.getElementById('captcha-button');
      this.captchaDisable = true;
      window.initAliyunCaptcha({
        SceneId: 'lwyh0wht', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: '18u3b3', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        immediate: true,
        slideStyle: {
          width: 340,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
    clearALiYunCaptcha () {
      this.captchaButton = null;
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById('aliyunCaptcha-mask')?.remove();
      document.getElementById('aliyunCaptcha-window-popup')?.remove();
      if (this.captcha) {
        this.captcha.destroyCaptcha();
      }
    },
    // 阿里云人机校验实例
    getInstance (instance) {
      this.captcha = instance;
    },
    // 获取短信验证码
    sendMobileCode (mobile, requestType, captchaVerifyParam) {
      return api.sendMobileCode({
        mobile,
        requestType,
        captchaVerifyParam,
      }).then(res => {
        console.log(res);
        if (res.data.data !== '400') {
          this.$toast(res.data.data);
          this.codeBtnText = `${this.timerNum}S后重新获取`;
          console.log(this.codeBtnText);
          this.timer = setInterval(() => {
            this.timerNum --;
            this.codeBtnText = `${this.timerNum}S后重新获取`;
            if (this.timerNum < 0) {
              this.captchaDisable = false;
              this.timerNum = 60;
              this.codeBtnText = '重新获取';
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
          return true;
        } else {
          return false;
        }
      }).catch(err => {
        clearInterval(this.timer);
        this.timer = null;
        this.timerNum = 60;
        this.codeBtnText = '获取验证码';
        return false;
      });
    },
    // 验证通过后调用
    onBizResultCallback () {
      console.log(111111111, 'onBizResultCallback');
    },
  }
};
